import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Calendar,NavDrawer } from "../../../export/drawer";
import { closeNavigationDrawer } from "../../../export/drawer";
import { changeSelectedMenuItemId } from "../../../export/drawer";
import PageLayout from "../../design/wilya-page-layout";
import { FilterProvider } from "../filters/filter-context";
import { useEdgeBoxStyle } from "./use-edge-height-style";

const MiniDrawer = () => {
	const dispatch = useDispatch();
  const boxStyle = useEdgeBoxStyle();
  const currentUserId = useSelector((state: any) => state.user?.userData?.id);
	useEffect(() => {
		// To select Flex schedule menu item
		dispatch(changeSelectedMenuItemId(2));
    dispatch(closeNavigationDrawer());
	}, [dispatch]);

	return (
		<Box
			sx={{
        ...boxStyle,
				display: "flex",
				backgroundColor: "#F5F5F5",
				width: "100%",
			}}
		>
			<CssBaseline />
			<NavDrawer keepSettingOpen={false} />
			<PageLayout>
        <FilterProvider filterKey={`flex-scheduler-${currentUserId}`}>
          <Calendar />
        </FilterProvider>
			</PageLayout>
		</Box>
	);
};

export default MiniDrawer;
